import { t } from '@/i18n';

/** Shortens a long id/number for table/dialog display: keeps the head and tail, elides the middle. */
export function shortenMiddle(value: string, headLen = 10, tailLen = 6): string {
  if (value.length <= headLen + tailLen + 1) return value;
  return `${value.slice(0, headLen)}…${value.slice(-tailLen)}`;
}

/** "X min/godz. temu" for a recent ISO timestamp, falling back to a locale
 *  date once it's a day old — mirrors NotificationBell's relativeTime. */
export function formatRelativeTime(iso: string): string {
  const minutes = Math.round((Date.now() - new Date(iso).getTime()) / 60_000);
  if (minutes < 1) return t('notifications.justNow');
  if (minutes < 60) return t('notifications.minutesAgo', { m: minutes });
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return t('notifications.hoursAgo', { h: hours });
  return new Date(iso).toLocaleDateString('pl-PL');
}

/** Compact single-line rendering of an event's detailJson for the timeline list. */
export function shortenDetailJson(detail: Record<string, unknown> | null, maxLen = 160): string | null {
  if (!detail || Object.keys(detail).length === 0) return null;
  const json = JSON.stringify(detail);
  return json.length > maxLen ? `${json.slice(0, maxLen)}…` : json;
}
